module.exports = __webpack_public_path__ + "statics/img/SmartManagement-4.f2a4457f.png";